module.exports = __webpack_public_path__ + "img/trash.2b43fcb3.svg";